<div class="signature-modal-overlay" (click)="onClose()">
  <div class="signature-modal-panel" (click)="$event.stopPropagation()">
    <div class="signature-modal-header">
      <h3>
        <fa-icon [icon]="faPenNib" class="mr-2 text-brand-red/70"></fa-icon>
        Firmar contrato
      </h3>
      <button
        type="button"
        class="signature-modal-close"
        (click)="onClose()"
        [disabled]="isSubmitting"
        aria-label="Cerrar"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <p class="signature-modal-hint">
      Dibuja tu firma en el recuadro con el ratón o el dedo y confirma para firmar
      @if (documentName) {
        <strong>{{ documentName }}</strong>
      } @else {
        el contrato
      }.
    </p>

    <div class="signature-canvas-wrapper">
      <canvas
        #signatureCanvas
        width="600"
        height="220"
        (mousedown)="startDrawing($event)"
        (mousemove)="draw($event)"
        (mouseup)="stopDrawing()"
        (mouseleave)="stopDrawing()"
        (touchstart)="startDrawing($event)"
        (touchmove)="draw($event)"
        (touchend)="stopDrawing()"
      ></canvas>
      @if (!hasSignature) {
        <span class="signature-placeholder">Firma aquí</span>
      }
    </div>

    <div class="signature-modal-actions">
      <button
        type="button"
        class="app-btn app-btn--secondary"
        (click)="clear()"
        [disabled]="isSubmitting || !hasSignature"
      >
        <fa-icon [icon]="faEraser"></fa-icon>
        Borrar
      </button>
      <div class="flex gap-2">
        <button
          type="button"
          class="app-btn app-btn--secondary"
          (click)="onClose()"
          [disabled]="isSubmitting"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="app-btn app-btn--primary"
          [disabled]="!hasSignature || isSubmitting"
          (click)="confirmSignature()"
        >
          @if (isSubmitting) {
            <fa-icon [icon]="faSpinner" class="animate-spin"></fa-icon>
            Firmando...
          } @else {
            Confirmar firma
          }
        </button>
      </div>
    </div>
  </div>
</div>
